import { Component, input } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: "sxw-popup-wrapper",
  templateUrl: "./popup-wrapper.component.html",
  styleUrls: ["./popup-wrapper.component.scss"],
  imports: [RouterOutlet],
})
export class PopupWrapperComponent {
  outletName = input("popups");
}
